import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTwitch$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTwitch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c059cd209286d5dee9d4a6ed7f90150c6bf5d8c0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3208c1f62fe6452a1b561be310d8d937574c71f8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '758cedffe18198676029f03240e470008f78e858', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 5.857 6.857 3h10.857v8l-5.143 5.143h-2.285L7.429 19v-2.857H4zm10.286 6.857 2.285-2.285V4.143H7.43v8.571H10v2l2-2zm-.572-6.571h1.143V9.57h-1.143zm-2 0h-1.143V9.57h1.143z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-twitch", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-twitch"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-twitch":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTwitch$1);
            }
            break;
    } });
}

const CosmosIconTwitch = CosmosIconTwitch$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTwitch, defineCustomElement };
